import React from "react";
import RenderCompletionCallback from "views/components/widgets/RenderCompletionCallback";
class RenderCompletionObserver extends React.Component {
  constructor() {
    super(...arguments);
    this._renderComplete = false;
    this._handleRenderComplete = () => {
      if (this._renderComplete) {
        return;
      }
      this._renderComplete = true;
      const { onRenderComplete } = this.props;
      onRenderComplete();
    };
  }
  render() {
    const { children } = this.props;
    return /* @__PURE__ */ React.createElement(RenderCompletionCallback.Provider, { value: this._handleRenderComplete }, children);
  }
}
export default RenderCompletionObserver;
